/* jslint browser: true */
/* global document */

(function bootstrapAngularApp(angular) {
  /**
   * Http interceptor
   *
   * @ngdoc factory
   * @return {object}
   */
  function httpInterceptor($q, $location, $rootScope, handleError) {
    /**
     * Accepts / rejects an http response based on the status code
     *
     * @param  {object} response - http resopnse
     * @return {promise}
     */
    function handleResponse(response) {
      const requestString = JSON.stringify(response.config.data);
      const suppressedRequestIndex =
        $rootScope.suppressedRequests.indexOf(requestString);

      if (response instanceof Error) {
        return $q.reject(response);
      }

      if (response.status === 401) {
        window.location.href = `/signin?message=unauthorised&next=${$location.$$absUrl}`;
        return $q.reject(response);
      }

      if (response.status >= 400) {
        // Show alert if this request hasn't suppressed form validation erorrs
        if (suppressedRequestIndex !== -1) {
          if (response.status !== 422) {
            handleError(response);
          }

          $rootScope.suppressedRequests.splice(suppressedRequestIndex, 1);
        } else {
          handleError(response);
        }

        return $q.reject(response);
      }

      // return $q.when(response);
      return response;
    }

    return {
      response: handleResponse,
      responseError: handleResponse,
    };
  }
  httpInterceptor.$inject = ["$q", "$location", "$rootScope", "handleError"];

  /**
   * Performs any initial setup needed before the app runs
   *
   * @return {void}
   */
  function configureApp(
    $interpolateProvider,
    $httpProvider,
    $locationProvider,
  ) {
    // Change template delimiters
    $interpolateProvider.startSymbol("{(");
    $interpolateProvider.endSymbol(")}");

    // Always send X-Requested-With header
    // eslint-disable-next-line no-param-reassign
    $httpProvider.defaults.headers.common["X-Requested-With"] =
      "XMLHttpRequest";

    // Add http interceptor
    $httpProvider.interceptors.push("httpInterceptor");

    // Tell locationProvider to use HTML5 mode
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: true,
      rewriteLinks: false,
    });
  }
  configureApp.$inject = [
    "$interpolateProvider",
    "$httpProvider",
    "$locationProvider",
  ];

  // bootstrap the app
  angular
    .module("app", [
      "ng",
      "ngSanitize",
      "ngResource",
      "ngRoute",
      "ngFileUpload",
      "ngCookies",
      "uiCropper",
      "ui.bootstrap",
      "ui.select",
      "fiestah.money",
      "iso-3166-country-codes",
      "yaru22.angular-timeago",
      "rzModule",
      "dndLists",
      // 'minicolors',
      "ui.select",
      "chart.js",
      "ui.tree",
    ])
    .factory("httpInterceptor", httpInterceptor)
    .config(configureApp)
    .constant("settings", {
      apiBase: "/api",
      maxImageUploadSize: 2 * 1024 * 1024, // 2MB
      maxUploadSize: 512 * 1024 * 1024, // 512MB
    })
    .constant("_", window._)
    .provider({
      // tell angular that our app runs inside <body>.
      // we can't load angular services outside of angular (ie. inside react) without this.
      $rootElement: function getRootElement() {
        this.$get = function getElement() {
          return angular.element(document.getElementsByTagName("body"));
        };
      },
    });
})(angular);
